import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Product, ProductDialogType} from "../../shared/models/product";
import {ProductService} from "../services/product.service";
import {ProductEditComponent} from "../product/product-edit/product-edit.component";
import {MatDialog} from "@angular/material/dialog";
import {Brand} from "../../shared/models/brand";
import {BrandService} from "../services/brand.service";
import {NGXLogger} from "ngx-logger";
import {BrandEditComponent} from "./brand-edit/brand-edit.component";
import {AuthService} from "../../core/auth/auth.service";
import {Permissions} from "../../core/auth/permissions";
import {FacadeService} from "../../shared/services/facade.service";
import { take } from 'rxjs';
import { DeleteDialogComponent } from 'src/app/shared/components/delete-dialog/delete-dialog.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.scss']
})
export class BrandComponent implements OnInit {
  public brand! : Brand;
  public products: Array<Product> = [];
  brandId! : number ;
  settingsTitle : string = "Settings";

  allowBrandCreate : boolean = false;
  allowBrandEdit : boolean = false;
  allowBrandDelete : boolean = false;

  /**
   * Constructor
   * @param dialog Dialog instance
   * @param route Route instance
   * @param router Router instance
   * @param productService Product service instance
   * @param brandService Brand service instance
   * @param logger Logger instance
   */
  constructor(public dialog: MatDialog,
              private route: ActivatedRoute,
              public router: Router,
              private productService : ProductService,
              private brandService : BrandService,
              private logger: NGXLogger,
              private authService : AuthService,
              private facadeService: FacadeService,
              private toastr: ToastrService) {
    let param = this.route.snapshot.paramMap.get('brandId') as string;
    this.brandId = parseInt(param, 10);

    this.brandService.getBrands().then (brands => {
      let foundBrand = brands.find(brand => brand.id == this.brandId);
      if (foundBrand != undefined) {
        this.brand = foundBrand;
        this.products = this.brand.products
          // sort enabled products at the top, then by name
          .sort((a, b) => (+b.isActive) - (+a.isActive) || a.code - b.code);

        this.facadeService.setPageTitleContext(`Brand Settings - ${foundBrand.name}`);
      }
    });
  }

  /**
   * Init
   */
  ngOnInit(): void {
    this.authService.role.pipe(take(1)).subscribe(role => {
      let accessPermissionList : string[] = this.authService.getAccessPermissions(role);

      if(accessPermissionList.includes(Permissions.Type.ADD_NEW_BRAND)) { this.allowBrandCreate = true; }
      if(accessPermissionList.includes(Permissions.Type.EDIT_BRAND)) { this.allowBrandEdit = true; }
      if(accessPermissionList.includes(Permissions.Type.DELETE_BRAND)) { this.allowBrandDelete = true; }
    });
  }

  /**
   * Add product
   */
  add() {
    let product = Product.init();

    product.brandId = this.brandId;

    let dialogRef = this.dialog.open(ProductEditComponent, {
      data: { dialogType: ProductDialogType.Add, product: product, title : "Add New Product" },
    });

    dialogRef.afterClosed().subscribe(createdProduct => {
      if (!!createdProduct) {
        this.logger.debug(`Dialog result: ${JSON.stringify(createdProduct)}`);
        this.productService.addProduct(createdProduct).then((products) => {
            this.products = products as Array<Product>;
            this.logger.debug("Update results:" + JSON.stringify(products))
          }
        );
      };
    });
  }

  /**
   * Edit product
   * @param product Product to edit
   */
  // edit(product : ProductDetails): void {
  //   this.logger.debug("Editing Product:" + JSON.stringify(product));
  //   this.router.navigate(['/configuration/brand/'+ this.brand.id + '/product/' + product.productId] );
  // }

  /**
   * Delete product
   * @param product Product to delete
   */
  delete(product : Product) : void {
    let dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: { setting: product,  title : "Confirm Delete" },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != "" && result != undefined) {
        this.toastr.success(`Product ${product.name} deleted successfully.`, 'Product Deleted');
        this.productService.deleteProduct(product).then (products => {
          this.products = products;
        });
      }

    });

  }

  /**
   * Edit brand
   */
  editBrand() {
    this.logger.debug("Editing Brand:" + JSON.stringify(this.brand));
    let dialogRef = this.dialog.open(BrandEditComponent, {
      data: { brand: this.brand,  title : "Edit" },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.logger.debug(`Dialog result: ${JSON.stringify(result)}`);
      if (result != "" && result != undefined) {
        this.brandService.updateBrand(result).then((brands) => {
            let foundBrand = brands.find(brand => brand.id == this.brand.id);
            if (foundBrand != undefined) {
              this.brand = foundBrand;
            }
            this.logger.debug("Update results:" + JSON.stringify(brands))
          }
        );
      }
    });
  }
}
